import { motion } from "framer-motion";

export const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, ease, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ index, children }) => (
  <div className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-zinc-400">
    <span className="text-volt">{index}</span>
    <span className="h-px w-10 bg-white/20" />
    <span>{children}</span>
  </div>
);
